module.exports = __webpack_public_path__ + "static/apple-icon-114x114.6bf25f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-114x114.png
// module id = 544
// module chunks = 168707334958949